import { useCallback } from 'react';

import { useExtendedErrorHandling } from 'js/app/hooks/auth/hooks/useLoginByCredentialsWithHandlingError/hooks/useExtendedErrorHandling';
import { useLoginByCredentials } from 'js/hooks/auth/hooks/useLoginByCredentials';

export const useLoginByCredentialsWithHandlingError = () => {
    const extendedErrorHandling = useExtendedErrorHandling();
    const loginByCredentials = useLoginByCredentials();

    return useCallback(async (userNameFormatted, password, rememberMeLogin, afterRegisterLogin) =>
        loginByCredentials(userNameFormatted, password, rememberMeLogin, afterRegisterLogin)
            .catch((response) => {
                const error = extendedErrorHandling({
                    response,
                    title: userNameFormatted,
                    userName: userNameFormatted,
                    ignorePopupForErrorCodes: [22],
                    afterRegisterLogin
                });

                return Promise.reject(error || response);
            }),
    [extendedErrorHandling, loginByCredentials]);
};
